(function($, ns) {
    'use strict';

    var cfg = {
        cache: {
            videoIcon: '.video-icon',
            iframe: 'iframe'
        },
        data: {
            youtubeId: 'youtube-id',
            youtubeAutoplay: 'youtube-autoplay',
            youtubeFullScreen: 'youtube-fullscreen',
            videoPreviewImage: 'preview-image'
        },
        classes: {
            videoIconVisible: 'video-icon-visible',
            videoPaused: 'video-paused',
            loaded: 'loaded',
            acceptCookies: 'accept-cookies',
        },
        events: {
            click: 'click'
        }
    };

    ns.YoutubeVideo = function(container) {
        this.container = container;
        this.settings = cfg;

        const classes = this.settings.classes;

        const cookieValue = ns.fn.readCookie('analyticsOptOut');
        if (cookieValue === undefined || cookieValue == 'true') {
          this.container.addClass(classes.acceptCookies);
        } else {
          this.container.removeClass(classes.acceptCookies);
          this.init();
        }
    };

    ns.YoutubeVideo.prototype = {
        init: function() {
            this.cacheItems();

            if (this.container.length) {
                this.buildElement();
                this.bindEvents();
                this.activate();
            }
        },
        cacheItems: function() {
            let settings = this.settings,
                data = settings.data;

            this.youtubeId = this.container.data(data.youtubeId);

            this.youtubeAutoplay = this.container.data(data.youtubeAutoplay);
            this.youtubeAutoplay =
                this.youtubeAutoplay !== undefined ? this.youtubeAutoplay : false;

            this.youtubeFullScreen = this.container.data(data.youtubeFullScreen);
            this.youtubeFullScreen =
                this.youtubeFullScreen !== undefined ? this.youtubeFullScreen : false;

            this.videoPreviewImage = this.container.data(data.videoPreviewImage);

            this.isPlaying = this.youtubeAutoplay;
        },
        buildElement: function() {
            let settings = this.settings,
                classes = settings.classes;

            this.youtubeElement = $('<div></div>');
            this.videoIcon = $('<div class="video-icon"></div>');

            if (!this.youtubeAutoplay) {
                this.videoIcon.addClass(classes.videoIconVisible);
            }

            var previewImageUrl = this.videoPreviewImage
                ? this.videoPreviewImage
                : '//i.ytimg.com/vi/' + this.youtubeId + '/maxresdefault.jpg';

            this.videoFirstFrame = $(
                '<img src="' + previewImageUrl + '" class="youtube-video-thumb" alt="video '+ this.youtubeId +' preview image "/>'
            );

            this.videoIcon.append(this.videoFirstFrame);

            this.videoIcon.append(this.youtubeElement);
            this.container.append(this.videoIcon);
        },
        bindEvents: function() {
            let settings = this.settings,
                events = settings.events;

            this.videoIcon.on(events.click, () => {
                this.play();
            });

            $(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange', e => {
                if (document.fullscreenElement !== null) {
                    if (document.fullscreenElement) {
                        window.YoutubeFullscreen = true;
                        return;
                    } else if (document.webkitFullscreenElement) {
                        window.YoutubeFullscreen = true;
                        return;
                    } else if (document.mozFullScreenElement) {
                        window.YoutubeFullscreen = true;
                        return;
                    } else {
                        window.YoutubeFullscreen = false;
                        this.pause();
                        return;
                    }
                }
            });
        },
        activate: function() {
            if (window.YT === undefined && !window.YoutubeLoading) {
                window.YoutubeLoading = true;
                // Load the IFrame Player API code asynchronously.
                let tag = document.createElement('script');
                tag.src = '//www.youtube.com/player_api';
                let firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                // YouTube player after the API code downloads.
                window.onYouTubePlayerAPIReady = () => {
                    window.YoutubeLoading = false;
                    this.initPlayer();
                };
            } else {
                this.initPlayer();
            }
        },
        initPlayer: function() {
            if (window.YT === undefined || window.YT.Player === undefined) {
                setTimeout(() => {
                    this.initPlayer();
                }, 200);
                return;
            }
            this.youtubePlayer = new YT.Player(this.youtubeElement[0], {
                height: '360',
                width: '640',
                videoId: this.youtubeId,
                modestbranding: true,
                autoplay: this.autoplay ? 1 : 0
            });

            
            this.youtubePlayer.addEventListener('onReady', () => {
                /*ns.fn.debounce(() => {
                    this.playStateChanged();
                }, 100);*/
                this.stopLoading();
            });
        },
        playStateChanged: function() {
            if (this.youtubePlayer.getPlayerState === undefined) {
                return;
            }
            let state = this.youtubePlayer.getPlayerState();
            if (state === 0 || state === 2 || state === 0) {
                if (state === 0) {
                    ns.fn.exitFullScreen();
                    window.YoutubeFullscreen = false;
                }
                this.displayPause();
            } else if (state === 1 || state === 3) {
                this.displayPlay();
            }
        },
        play: function() {
            if (window.YT && this.youtubePlayer && this.youtubePlayer.playVideo) {
                this.displayPlay();
                this.youtubePlayer.playVideo();
                if (this.youtubeFullScreen) {
                    this.launchIntoFullscreen(this.youtubePlayer.getIframe());
                }
            } else {
                this.displayPlay();
                setTimeout(() => {
                    this.youtubePlayer.playVideo();
                    if (this.youtubeFullScreen) {
                        this.launchIntoFullscreen(this.youtubePlayer.getIframe());
                    }
                }, 750);
            }
            this.isPlaying = true;
        },
        displayPlay: function() {
            let settings = this.settings,
                classes = settings.classes;
            this.videoIcon.removeClass(classes.videoIconVisible).removeClass(classes.videoPaused);
        },
        pause: function() {
            this.youtubePlayer.pauseVideo();
            this.isPlaying = false;
        },
        displayPause: function() {
            let settings = this.settings,
                classes = settings.classes;
            // check if we are not in full screen mode!!!
            if (window.YoutubeFullscreen) {
                return;
            }
            this.videoIcon.addClass(classes.videoIconVisible).addClass(classes.videoPaused);
        },
        stopLoading: function() {
            let settings = this.settings,
                classes = settings.classes;

            setTimeout(() => {
                this.videoIcon.addClass(classes.loaded);
                
                this.youtubePlayer.addEventListener('onStateChange', () => {
                    /*ns.fn.debounce(() => {
                        this.playStateChanged();
                    }, 100);*/
                    this.playStateChanged();
                });
            }, 750);
            
        },
        launchIntoFullscreen: function(element) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        }
    };

    return ns;
})(window.jQuery, window.Dom || {});
